import React from 'react';
import styled from 'styled-components';
import { config } from '@keytrade/functions';
import { Icon } from '@keytrade/components-icon';

import { mediaQuery } from '@/utils/helpers';
import useTranslations from '@/hooks/useTranslations';

const { list: colors } = config.colors;
const { getFont } = config.fonts;

const Pill = styled.div`
  display: none;
  ${mediaQuery.md(`
    display: flex;
    align-items: center;
    padding: 4px 10px;
    margin-right: 12px;
    background-color: ${colors.White};
    border-radius: 12px;
    margin-top: 5px;
    margin-bottom: 5px;
    &:last-of-type
    {
        margin-right: 20px;
    }
    cursor: pointer;
  `)}
`;

const PillText = styled.span`
  display: flex;
  margin-left: 9px;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  font-family: ${({ theme }) => getFont(theme, 'semiBold')};
`;

export type PillType = {
  value: string;
  type?: string;
  componentType?: string;
  removeFilter: () => void;
};

const FilterPill: React.FC<PillType> = ({
  componentType,
  value,
  type,
  removeFilter,
}) => {
  const { t } = useTranslations();

  return (
    <Pill onClick={removeFilter}>
      <Icon icon='icn_cross' size='12px' />
      <PillText>
        {t(
          `${componentType ? `${componentType}.` : ''}${
            type ? `${type}.` : ''
          }${value}`,
        )}
      </PillText>
    </Pill>
  );
};

export default FilterPill;
